// Zoom.js
import { h } from 'preact';
import { useRef, useEffect } from 'preact/hooks';

const Zoom = ({ src, isZoomed, mousePosition, setMousePosition }) => {
  const containerRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!isZoomed) return;
    const { left, top, width, height } = 
    e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - left) / width;
    const y = (e.clientY - top) / height; 
    setMousePosition({ x, y });
    
    containerRef.current.style.backgroundPosition = 
    `${(x * 100).toFixed(2)}% ${(y * 100).toFixed(2)}%`;
  }; 

  useEffect(() => {
    if (!containerRef.current) return;

    if (!isZoomed) {
      containerRef.current.style.backgroundPosition = 'center center';
    } else {
      containerRef.current.style.backgroundPosition = 
      `${mousePosition.initialBackgroundPositionX}% 
       ${mousePosition.initialBackgroundPositionY}%
       `;
      containerRef.current.style.backgroundSize = '250%';
    }
  }, [isZoomed]);

  useEffect(() => {
    // Reset mouse position when zoom is toggled
    if (!isZoomed) {
      setMousePosition({ x: 0, y: 0 });
    }
  }, [isZoomed]);

  return (
    <div
      className={`w-full h-full ${isZoomed ? 'cursor-zoom-out' : ''}`}
      style={{
        backgroundImage: `url(${src})`,
      }}
      ref={containerRef}
      onMouseMove={handleMouseMove}
    />
  );
};

export default Zoom;
